module.exports = __webpack_public_path__ + "img/logo.9a616e90.svg";